<script lang="ts">
    import clickSound from '@src/utils/useClickSound.js';

    let className = '';
    export let selectedValue;
    export let value = null;
    export { className as class };

    let activeClasess = null;

    $: {
        activeClasess = selectedValue && '!border-[3px] !border-cross-accent !font-bold !text-white';
    }
</script>

<button
    type="button"
    on:click
    use:clickSound={{ sound: 'audio_basic_click' }}
    class="btn-base svg-fill relative inline-flex h-10 items-center justify-center overflow-hidden rounded-full border-[3px] border-solid border-transparent bg-[#1F77FF1A] px-3
  py-2 text-center font-Roboto text-md text-cross-t-caption hover:cursor-pointer hover:border-white/20 phone:px-4 desktop:h-12 desktop:px-4 desktop:py-3 desktop:text-xl {activeClasess} {className}"
>
    <slot>
        {value}
    </slot>
</button>

<style>
    .svg-fill > :global(svg path) {
        fill: theme(colors[cross-t-caption]);
    }

    .active-border :global(svg path) {
        fill: white;
    }
</style>
